import React from "react";
import { Grid, Checkbox } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { getMessage } from "../../CommonFuntion/messages";

const LayoutApprovalSection = ({
  layoutInformation,
  layoutApproval,
  setLayoutApproval,
  setOrderOnHold,
  setLayoutApprovalChild,
  setOrderOnHoldChild,
  orderOnHold,
  isInteralOrAdminUser,
}) => {
  if (!layoutInformation.generateLayout) return null;

  return (
    <Grid item xs={24} sm={12} md={8}>
      <div className="flex-container2">
        
        {/* Checkbox 1: Generate layout with Hold */}
        <div className="flex-item-left2">
          Generate layout approval with Hold :
          <Checkbox
            checked={layoutApproval && orderOnHold}
            name="layoutApprovalWithHold"
            onChange={(event) => {
              const isChecked = event.target.checked;
              if (isChecked) {
                // Turn ON layout and ON hold
                setLayoutApproval(true);
                setOrderOnHold(true);
                setLayoutApprovalChild(true);
                setOrderOnHoldChild(true);
              } else {
                // Unchecking turns off the feature completely
                setLayoutApproval(false);
                setOrderOnHold(false);
                setLayoutApprovalChild(false);
                setOrderOnHoldChild(false);
              }
            }}
            disabled={layoutInformation.forceLayout}
          />
        </div>

        {/* Checkbox 2: Generate layout without Hold */}
        {isInteralOrAdminUser && (
          <div className="flex-item-left2">
            Generate Layout approval without hold :
            <Checkbox
              checked={layoutApproval && !orderOnHold}
              name="layoutApprovalWithoutHold"
              onChange={(event) => {
                const isChecked = event.target.checked;
                if (isChecked) {
                  // Turn ON layout but OFF hold
                  setLayoutApproval(true);
                  setOrderOnHold(false);
                  setLayoutApprovalChild(true);
                  setOrderOnHoldChild(false);
                } else {
                  // Unchecking turns off the feature completely
                  setLayoutApproval(false);
                  setOrderOnHold(false);
                  setLayoutApprovalChild(false);
                  setOrderOnHoldChild(false);
                }
              }}
              disabled={layoutInformation.forceLayout}
            />
          </div>
        )}
      </div>
      
      <InfoIcon color="primary" />
      <span style={{ fontSize: 12, color: "red" }}>
        {getMessage("GenerateLayoutCheckoutMessage")}
      </span>
    </Grid>
  );
};

export default LayoutApprovalSection;